import { Component, OnInit, Input, ViewChild, ElementRef, Output } from '@angular/core';
import { DataModel } from '../../../../models/data.model';
import { AngularFirestore } from 'angularfire2/firestore';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { Subject } from 'rxjs/Rx';


interface IProdutoComplmento {
    id?: String;
    texto: String;
    grupo: number;
}

class ProdutoComplementoDataModel extends DataModel<IProdutoComplmento> {

}


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'produto-complemento',
    templateUrl: 'produto-complemento.html'
})

// tslint:disable-next-line:component-class-suffix
export class ProdutoComplementoControl implements OnInit {
    fItemProduto: any;
    produtoId: String;
    items: IProdutoComplmento[];
    collection: string;
    dataModel: ProdutoComplementoDataModel;
    item: any = {};
    editing = false;
    colunas = [
        { field: 'texto', text: 'Descrição', width: 120 },
        { field: 'grupo', text: 'Grupo', width: 50, info: 'Agrupar items que são de opção exclusiva' }
    ];
    @ViewChild('grid') grid: ElementRef<MatDataGridComponent>;

    @Output()
    change = new Subject<any>();

    @Input()
    get value() {
        return this.fItemProduto;
    }
    set value(x) {
        this.fItemProduto = x;
        this.produtoId = x.id;
        // console.log(this.produtoId);
        this.carregarComplemento(this.produtoId);

    }

    constructor(private db: AngularFirestore) {


    }

    ngOnInit() { }

    carregarComplemento(id: String) {
        this.collection = 'nc-produtos/' + id + '/complementos';
        this.dataModel = new ProdutoComplementoDataModel(this.db, '');
        this.dataModel.collectionName(this.collection);
        this.dataModel.snapshot(null, (rsp) => {
            this.items = rsp;
            if (this.change) { this.change.next(rsp); }
        });
    }


    doEditItemCompl(ds) {
        console.log(ds);
        if (ds.state === 'dsInsert') {
            this.item = {};
        } else {
            this.item = ds.values;
        }
        this.editing = true;
    }

    salvarItemCompl(item) {
        item.grupo = parseFloat(item.grupo || '0');
        this.dataModel.post(item);

        this.editing = false;

    }
    cancelarItemCompl() {
        this.editing = false;
    }

    doDeleteItemCompl(item) {
        this.dataModel.deleteRow(item.id);
        this.editing = false;
    }
}
